/*
 * @Description: 线上合同签署
 * @Author: ljl
 * @Date: 2024-03-12
 */

import VALIDATOR from "./../../../FormVerification/validator";

export const Rules = {
  operatorName: [{ required: true, message: " ", trigger: ["blur", "change"] }],
  operatorMobile: [{required: true,validator: VALIDATOR.validatePhone,trigger: ["blur", "change"]}],
  operatorIdCard: [{required: true,validator: VALIDATOR.validateCard,trigger: ["blur", "change"]}],
  operatorEmail: [{ required: true, validator: VALIDATOR.validateEmail, trigger: ["blur", "change"] }],
  operatorAddress: [{ required: true, message: " ", trigger: ["blur", "change"] }],
  cooperatorName: [{ required: true, message: " ", trigger: ["blur", "change"] }],
  paymentBankAccountNo: [{required: true, validator: VALIDATOR.vdtCheckNum,trigger: ["blur", "change"]}],
  paymentBankBranchName: [{ required: true, message: " ", trigger: ["blur", "change"] }],
  amount: [{ required: true, validator: VALIDATOR.vdtCheckPrice, trigger: ["blur", "change"] }],
  smsCode: [{ required: true, validator: VALIDATOR.vdtCheckNum, trigger: ["blur", "change"] }],
}


// WEBPACK FOOTER //
// ./src/views/onlineContractSign/vdt/form_validata.js